import React, { useRef } from 'react';
import { HashRouter } from "react-router-dom";
import { Route,  Switch } from "react-router";

import Header from './Header';
import Home from './home/Home';
import MarkdownView from './shared/MarkdownView';
import Pricing from './pricing/Pricing';

import { makeStyles, Theme, createStyles } from '@material-ui/core';
import TermsOfService from './docs/TermsOfService';
import Privacy from './docs/Privacy';
import Cookies from './docs/Cookies';
import Refunding from './docs/Refunding';
import Support from './docs/Support';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root : {
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
    },
  }),
);


const App: React.FC = () => {

  const mainRef = useRef<HTMLDivElement>(null);
  const classes = useStyles();

  return (
    <div className={classes.root} ref={mainRef}>
      <Header />
      <HashRouter>
        <Switch>
          <Route  path={"/docs/:type/:topic"} component={MarkdownView} key="docs" exact={true} />,
          <Route  path={"/docs/:type"} component={MarkdownView} key="docs" exact={true}  />,
          <Route  path="/plans" component={Pricing} key="plans"  />
          <Route  path="/tos" component={TermsOfService} key="tos"  />
          <Route  path="/privacy" component={Privacy} key="privacy"  />
          <Route  path="/cookies" component={Cookies} key="cookies"  />
          <Route  path="/refund" component={Refunding} key="refund"  />
          <Route  path="/support" component={Support} key="support"  />
          <Route  path="/" component={Home} key="home"  />
        </Switch>      
      </HashRouter>
    </div>
  );
}

export default App; 

//       <MarkdownView filePath="http://localhost:9999/help/help-config-firefox.md" />
